export enum PublishType {
  BASED_IN_DAYS = "BASED_IN_DAYS",
  BASED_IN_DATE = "BASED_IN_DATE",
}
